module.exports = __webpack_public_path__ + "static/media/gallery_02.57ccf68f.png";